
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppButton } from '@/components';
import useMessageSend from '@/modules/message/model/send';
import { ROUTE_NAME_MESSAGE } from '@/modules/message/router';

export default defineComponent({
    name: ROUTE_NAME_MESSAGE.SEND,
    components: { AppFormRow, AppInput, AppCard, AppSelect, AppButton },
    setup() {
        const { model, send, options, v$ } = useMessageSend();

        return { v$, model, options, send };
    }
});
